import { imageNodeName } from '../../../extensions/markdown';
import { ImgSizeAttr } from '../../../extensions/specs';
import { logger } from '../../../logger';
import { IMG_MAX_HEIGHT } from './const';
export function isImageNode(node) {
    return node.type.name === imageNodeName;
}
export const createImageNode = (imgType, opts) => async ({ result, file }) => {
    var _a;
    const attrs = {
        [ImgSizeAttr.Src]: result.url,
        [ImgSizeAttr.Alt]: (_a = result.name) !== null && _a !== void 0 ? _a : file.name,
    };
    if (opts.needDimmensions) {
        try {
            const sizes = await loadImage(file).then(getImageSize);
            Object.assign(attrs, sizes);
        }
        catch (err) {
            logger.error(err);
        }
    }
    return imgType.create(attrs);
};
export async function loadImage(imgFile) {
    return new Promise((resolve, reject) => {
        const img = document.createElement('img');
        img.src = URL.createObjectURL(imgFile);
        img.onload = () => {
            URL.revokeObjectURL(img.src);
            resolve(img);
        };
        img.onerror = (_e, _s, _l, _c, error) => reject(error);
    });
}
export function getImageSize(img) {
    return { height: String(Math.min(IMG_MAX_HEIGHT, img.height)) };
}
